import { render, staticRenderFns } from "./genjinAdd.vue?vue&type=template&id=a7e8045e&scoped=true&"
import script from "./genjinAdd.vue?vue&type=script&lang=js&"
export * from "./genjinAdd.vue?vue&type=script&lang=js&"
import style0 from "./genjinAdd.vue?vue&type=style&index=0&id=a7e8045e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e8045e",
  null
  
)

export default component.exports